import { getArticleById } from '@/mocks/articles';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';

export default function ArticleContent() {
  const { id } = useParams<{ id: string }>();
  const articleDetail = getArticleById(id);

  return (
    <article className="max-w-3xl mx-auto px-4 md:px-6 py-10 md:py-14">
      {/* Content */}
      <div
        className="prose prose-lg max-w-none
          prose-headings:font-heading prose-headings:text-foreground-900
          prose-p:text-foreground-700 prose-p:leading-relaxed prose-p:text-base md:prose-p:text-lg
          prose-strong:text-foreground-900
          prose-a:text-primary-600 prose-a:no-underline hover:prose-a:text-primary-700
          [&_p]:mb-5"
        dangerouslySetInnerHTML={{ __html: articleDetail.content }}
      />

      {/* Tags */}
      <div className="mt-10 pt-8 border-t border-background-200/70">
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-xs font-medium text-foreground-400 mr-1">标签：</span>
          {articleDetail.tags.map((tag) => (
            <span
              key={tag}
              className="px-3 py-1 rounded-full bg-background-100 text-foreground-600 text-xs font-medium hover:bg-secondary-100 hover:text-secondary-800 transition-colors cursor-pointer"
            >
              #{tag}
            </span>
          ))}
        </div>
      </div>

      {/* Share */}
      <div className="mt-6 flex items-center gap-3">
        <span className="text-xs font-medium text-foreground-400">分享到：</span>
        <button className="w-8 h-8 rounded-lg bg-foreground-900 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer">
          <i className="ri-weibo-line text-background-50 text-sm w-4 h-4 flex items-center justify-center"></i>
        </button>
        <button className="w-8 h-8 rounded-lg bg-foreground-900 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer">
          <i className="ri-wechat-line text-background-50 text-sm w-4 h-4 flex items-center justify-center"></i>
        </button>
        <button className="w-8 h-8 rounded-lg bg-foreground-900 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer">
          <i className="ri-link text-background-50 text-sm w-4 h-4 flex items-center justify-center"></i>
        </button>
      </div>
    </article>
  );
}
